<template>
  <v-container class="justify-center mt-16">
    <v-row justify="center">
      <v-col cols="12" sm="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat> ลงทะเบียน </v-toolbar>
          <v-row justify="center">
            <v-img
              alt="Vuetify Logo"
              class="justify-center shrink mt-6 mb-1"
              contain
              src="/img/register.png"
              transition="scale-transition"
              width="256"
            />
          </v-row>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                label="First name"
                name="first_name"
                prepend-icon="mdi-account"
                type="text"
                :rules="[required]"
                v-model="model.firstName"
              />
              <v-text-field
                label="Last name"
                name="last_name"
                prepend-icon="mdi-account"
                type="text"
                :rules="[required]"
                v-model="model.lastName"
              />

              <v-text-field
                label="Login"
                name="email"
                prepend-icon="mdi-account"
                type="text"
                :rules="[required, email]"
                v-model="model.email"
              />

              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                :rules="[required]"
                v-model="model.password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue" dark @click="$router.push('/authen/login')"
              >Login</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="pink" dark @click="clear">Clear</v-btn>
            <v-btn color="primary" dark @click="singup">Signup</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  name: "Singup",
  data: () => ({
    valid: false,
    snackbar: {
      show: false,
      text: "",
      color: "success",
    },
    model: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
    required: (value) => !!value || "Required.",
    email: (value) => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Invalid e-mail.";
    },
  }),
  methods: {
    async singup() {
      try {
        this.$refs.form.validate();
        if (this.valid) {
          const user = {
            firstName: this.model.firstName,
            lastName: this.model.lastName,
            email: this.model.email,
            password: this.model.password,
          };
          console.log("login", user);
          const result = await this.$auth.singup(user);
          console.log(result);
          if (result.result) {
            this.snackbar.text = "Success";
            this.snackbar.color = "success";
            this.snackbar.show = true;
            setTimeout(() => {
              this.$router.push("/authen/login");
            }, 2000);
          } else {
            this.model.username = "";
            this.model.password = "";
            this.snackbar.text = "Error";
            this.snackbar.color = "error";
            this.snackbar.show = true;
          }
        }
      } catch (error) {
        console.log("LOGIN: ", error);
        this.model.username = "";
        this.model.password = "";
        this.snackbar.text = "Error";
        this.snackbar.color = "error";
        this.snackbar.show = true;
      }
    },
    clear() {
      this.model.fullName = "";
      this.model.username = "";
      this.model.email = "";
      this.$refs.form.reset();
    },
  },
};
</script>